import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useUpdateWarehouse = (lcrId) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    ({ warehouseId, warehouse }) => axiosInstance.put(liveCleanroom(orgId)
      .updateWarehouse(lcrId, warehouseId), warehouse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['warehouseList', lcrId] });
        dispatch(showAlert({
          message: 'Warehouse updated successfully',
          type: 'success',
        }));
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error updating warehouse',
            type: 'error',
          }),
        );
      },
    },
  );
};
